import { trackEvent } from "@/js/helpers/tracking";

export const KORE_CHAT_SDK_BASE_URL =
  "https://d2w3zkq33l1i26.cloudfront.net/chatbot"; // The different SDK version live in this directory

export const CHAT_TYPES = {
  NONE: "None",
  GIGA: "Giga",
  PROACTIVE: "Proactive",
  PROACTIVE_V2: "ProactiveV2",
};

export const DEFAULT_CHAT_CONFIG = {
  chatType: CHAT_TYPES.NONE,
};

export const MICROMODAL_PROACTIVE_CHAT_CONFIG = {
  disableFocus: true,
  disableScroll: true,
  onShow: () => {
    trackEvent({
      action: "elementViewed",
      data: {
        elementType: "MODAL",
        position: "PROACTIVE CHAT MODAL",
        text: "Open",
      },
    });
  },
};
